import { theme } from '@/constants';

export const styles = {
  container: {
    height: '100vh',
    backgroundColor: theme.palette.primary.dark,
  },
  icon: {
    color: 'grey.A200',
  },
  list: {
    pl: 1.5,
  },
  listItem: {
    color: 'white',
  },
} as const;
